module.exports = __webpack_public_path__ + "img/valentinadiaz.c5952898.jpg";